export default __webpack_public_path__ + "static/media/microphone.b3d525c4.svg";